import { render } from "./lock-unlock-users-modal.vue?vue&type=template&id=6a629423&ts=true"
import script from "./lock-unlock-users-modal.vue?vue&type=script&lang=ts"
export * from "./lock-unlock-users-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__